import { render, staticRenderFns } from "./stockVenom.vue?vue&type=template&id=4ba87d3a"
import script from "./stockVenom.vue?vue&type=script&lang=js"
export * from "./stockVenom.vue?vue&type=script&lang=js"
import style0 from "./stockVenom.vue?vue&type=style&index=0&id=4ba87d3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports